/**
 * Sistemas em que um artigo pode ser publicado, na ordem em que aparecem no
 * cadastro. O rótulo não fica aqui: sai de getDescricaoAcessoSistema(), que lê a
 * descrição cadastrada do sistema ("Disponível VersoSAC", "Disponível VersoCall"...).
 */
const SISTEMAS_ACESSO = [
  {
    campo: "acessab2b",
    help: "Publica o artigo na central de ajuda do e-commerce, para o cliente.",
  },
  {
    campo: "acessacallcenter",
    help: "Publica o artigo para os operadores durante o atendimento telefônico.",
  },
  {
    campo: "acessafv",
    help: "Publica o artigo no aplicativo da força de vendas, para o representante.",
  },
  {
    campo: "acessachat",
    help: "Publica o artigo para os atendentes do chat.",
  },
  {
    campo: "acessasac",
    help: "Publica o artigo na base de conhecimento do SAC, usada no atendimento de tickets.",
  },
];

/**
 * Complemento dos tipos que vêm da API (/admin/faq/tipos), que traz apenas
 * label, cor e ícone. Tipo novo cadastrado no banco continua funcionando: só
 * aparece sem descrição.
 *
 * O tipo é apenas categoria: define o filtro, o ícone e a ordem nas centrais de
 * ajuda. Não muda editor, campos nem o que é permitido no conteúdo — por isso as
 * descrições são orientação editorial, não recurso liberado.
 */
const DESCRICOES_TIPO = {
  duvida: "Pergunta objetiva, com resposta curta e direta.",
  dica: "Orientação rápida de uso, em poucas linhas.",
  artigo: "Texto explicativo mais completo sobre um assunto.",
  tutorial: "Passo a passo da operação, do início ao fim.",
};

/**
 * Os tipos guardam o ícone no formato do FontAwesome ("faPlayCircle"), e o
 * fa-icon espera kebab-case ("play-circle"). Ícone não registrado em
 * components/icons.js renderiza vazio, sem erro.
 */
function iconeTipo(icone) {
  if (!icone) {
    return "";
  }

  return icone
    .replace(/^fa/, "")
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .toLowerCase();
}

function descricaoTipo(tipo) {
  return DESCRICOES_TIPO[tipo] || "";
}

export { SISTEMAS_ACESSO, DESCRICOES_TIPO, iconeTipo, descricaoTipo };
